import { render, staticRenderFns } from "./PanelMachines.vue?vue&type=template&id=2dcdd542&lang=pug&"
import script from "./PanelMachines.vue?vue&type=script&lang=js&"
export * from "./PanelMachines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports